import { Injectable, inject } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { Observable, Subject } from 'rxjs';
import { SaveableComponent } from '../../shared/interfaces/saveable-component';

@Injectable({ providedIn: 'root' })
export class PendingChangesGuard implements CanDeactivate<SaveableComponent> {
  private confirmation = inject(ConfirmationService);

  canDeactivate(component: SaveableComponent): boolean | Observable<boolean> {
    if (!component?.isDirty?.()) return true;

    const decision$ = new Subject<boolean>();

    this.confirmation.confirm({
      message: 'Wollen Sie die Änderungen wirklich verwerfen?',
      header: 'Änderungen verwerfen',
      acceptLabel: 'Verwerfen',
      rejectLabel: 'Abbrechen',
      icon: 'pi pi-exclamation-triangle',
      rejectButtonProps: {
        severity: 'secondary',
      },
      accept: () => { decision$.next(true); decision$.complete(); },   // Navigation erlauben
      reject: () => { decision$.next(false); decision$.complete(); },  // Navigation abbrechen
    });

    return decision$.asObservable();
  }
}